import styled from 'styled-components';

const SelectSubTitle = styled.div`
  color: rgba(0, 0, 0, 0.65);
  padding-top: 10px;
  font-size: 13px;
`;

export default SelectSubTitle;
